/**
 * Border classes for a fixed 4-item grid that renders as 2 cols × 2 rows on
 * mobile and a single row of 4 on `sm`+ — produces a clean divider "table"
 * look using only the outer wrapper's own border. Index-based because
 * `divide-x`/`divide-y` follow DOM order, not grid geometry, and would draw
 * the wrong lines once the layout reflows from 2 columns to 4.
 */
export const FOUR_UP_BORDERS = [
  'border-b border-r border-border sm:border-b-0',
  'border-b border-border sm:border-b-0 sm:border-r sm:border-border',
  'border-r border-border',
  '',
];
